import React from 'react';
import { isEmpty } from 'lodash';
import { Icon, MaybeWrap, UniversalLink } from '@plone/volto/components';
import AnfahrtSVG from 'volto-fzj-internet/icons/stickymenu/Anfahrt.svg';
import AnsprechpartnerSVG from 'volto-fzj-internet/icons/stickymenu/Ansprechpartner.svg';
import AZSVG from 'volto-fzj-internet/icons/stickymenu/AZ.svg';
import DownloadsSVG from 'volto-fzj-internet/icons/stickymenu/Downloads.svg';
import FacebookSVG from 'volto-fzj-internet/icons/stickymenu/Facebook.svg';
import InstagramSVG from 'volto-fzj-internet/icons/stickymenu/Instagram.svg';
import LupeSVG from 'volto-fzj-internet/icons/stickymenu/Lupe.svg';
import MedienspiegelSVG from 'volto-fzj-internet/icons/stickymenu/Medienspiegel.svg';
import MitarbeiterSVG from 'volto-fzj-internet/icons/stickymenu/Mitarbeiter.svg';
import PublikationenSVG from 'volto-fzj-internet/icons/stickymenu/Publikationen.svg';
import RSSSVG from 'volto-fzj-internet/icons/stickymenu/RSS.svg';
import TermineSVG from 'volto-fzj-internet/icons/stickymenu/Termine.svg';
import TwitterSVG from 'volto-fzj-internet/icons/stickymenu/Twitter.svg';
import WarenkorbSVG from 'volto-fzj-internet/icons/stickymenu/Warenkorb.svg';
import YouTubeSVG from 'volto-fzj-internet/icons/stickymenu/YouTube.svg';
import linkedinSVG from 'volto-fzj-internet/icons/linkedin.svg';

const iconMap = {
  anfahrt: AnfahrtSVG,
  ansprechpartner: AnsprechpartnerSVG,
  az: AZSVG,
  downloads: DownloadsSVG,
  facebook: FacebookSVG,
  instagram: InstagramSVG,
  lexicon: AZSVG,
  lupe: LupeSVG,
  medienspiegel: MedienspiegelSVG,
  mitarbeiter: MitarbeiterSVG,
  publikationen: PublikationenSVG,
  rss: RSSSVG,
  termine: TermineSVG,
  twitter: TwitterSVG,
  warenkorb: WarenkorbSVG,
  youtube: YouTubeSVG,
  linkedIn: linkedinSVG
};

const StickyMenu = (props) => {
  const { institut, institutsbereich, subsite } = props;

  const menu = isEmpty(subsite)
    ? isEmpty(institutsbereich)
      ? institut.sticky_menu
      : institutsbereich.sticky_menu
    : subsite.sticky_menu;

  return (
    <>
      {menu && !isEmpty(menu.items) && (
        <div className="sticky-menu">
          <ul>
            {menu.items.map((item) => (
              <React.Fragment key={item['@id']}>
                {item.icon && item.href && (
                  <li key={item['@id']} className="sticky-item">
                    <MaybeWrap
                      condition={item.href?.[0]?.['@id']}
                      href={item.href?.[0]?.['@id']}
                      as={UniversalLink}
                      title={item.title}
                    >
                      {item.icon && iconMap[item.icon] && (
                        <Icon name={iconMap[item.icon]} size="24px" />
                      )}
                    </MaybeWrap>
                  </li>
                )}
              </React.Fragment>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default StickyMenu;
